import { Notifications } from "src/requests/notifications/types";
import { action, fsa } from "ts-action";
import { NotificationId } from "../../globalTypes";

export * from "./template/actionCreators";
export * from "./system/actionCreators";

export const requestResolveNotification = action(
  "NOTIFICATIONS : RESOLVE > BY ID > REQUEST",
  fsa<{ notificationId: NotificationId }>()
);

export const receiveResolveNotification = action(
  "NOTIFICATIONS : RESOLVE > BY ID > RECEIVE",
  fsa<{ notificationId: NotificationId }>()
);

export const requestResolveNotifications = action(
  "NOTIFICATIONS : RESOLVE > MULTIPLE BY IDS > REQUEST",
  fsa<{ notificationIds: NotificationId[] }>()
);

export const receiveResolveNotifications = action(
  "NOTIFICATIONS : RESOLVE > MULTIPLE BY ID > RECEIVE",
  fsa<{ notificationIds: NotificationId[] }>()
);

export const terminateNotificationsConnection = action(
  "NOTIFICATIONS : TEMPLATE > TERMINATE CONNECTION"
);

export const resetNotificationsSlice = action(
  "NOTIFICATIONS : TEMPLATE > RESET SLICE TO DEFAULT STATE"
);

// "Smart" notification dismiss -
// does stuff according to notification type
export const handleNotificationDismiss = action(
  "NOTIFICATIONS : RESOLVE > MAPPING",
  fsa<{ id: NotificationId }>()
);

export const requestFetchAllNotifications = action(
  "NOTIFICATIONS : REQUEST > ALL"
);

export const receiveAllNotfications = action(
  "NOTIFICATIONS : RECEIVE > ALL",
  fsa<{ notifications: Notifications }>()
);

export const errorReceiveAllNotifications = action(
  "NOTIFICATIONS : RECEIVE > ALL > ERROR"
);

export const resolveNotifications = action(
  "NOTIFICATIONS : RESOLVE",
  fsa<{ notificationIds: number[] }>()
);
